import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { shiftsPartnerScopedAccessControl } from '../access-control/shiftsAccess.configuration'

const ShiftManagementPartnerScopedPage = lazy(
  () =>
    /* webpackChunkName: "ShiftManagementPartnerScopedPage" */
    import('../pages/ShiftManagement/partnerScopedPage')
)

/**
 * Partner-scoped (multi-banner) Shift Management.
 *
 * The access control sits on the wrapper rather than the leaf so it also lands in
 * `AccessControlsContext`, which is what the header's scope picker reads to decide which
 * banners are selectable.
 */
export const shiftsPartnerScopedRouter = (
  <DomainRoute route="shiftsPartnerScoped" accessControl={shiftsPartnerScopedAccessControl}>
    <DashSwitch>
      <DomainRoute exact route="shiftsPartnerScoped" component={ShiftManagementPartnerScopedPage} />
    </DashSwitch>
  </DomainRoute>
)
